<template>
  <div>
    <ServiceScreenLayout :parts="parts">
      <template v-slot:summary>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-5">
                <div class="row">
                    <label class="col-md-4 col-form-label" style="padding-left:25px">Billing Period:</label>
                  <div class="col-md-7" v-if="saleDefinition.definition.minutes.summary">
                    <BillingFilter
                      :baseArray="saleDefinition.definition.minutes.summary"
                      @selectedOption="changeSummary"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-spacing">
              <div class="col-md-12">
                <table
                    class="table table-bordered"
                    v-if="summaryList.length > 0"
                >
                    <thead>
                        <tr>
                            <th>Called Network</th>
                            <th>Duration (Min.)</th>
                            <th>Price (excl. VAT)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="sum in summaryList"
                            :key="sum.objKey"
                        >
                            <td>{{ sum.calledNetwork }}</td>
                            <td>{{ formattedDuration(sum.duration) }}</td>
                            <td>{{ currencyFormat(sum.priceExVat) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="alert alert-info">
                    Please select a Billing Period.
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:cdr>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-5">
                <div class="row">
                  <label class="col-md-4 col-form-label" style="padding-left:25px">Billing Period:</label>
                  <div class="col-md-7">
                    <select 
                      class="form-control billing-period-select"
                      @change="getCdrForPeriod($event.target.value)"
                    >
                      <option value="" disabled selected>Select billing period</option>
                      <option 
                        v-for="option in cdrPeriods" 
                        :key="option" 
                        :value="option"
                      >
                        {{ option }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-spacing">
              <div class="col-md-12">
                <table
                    class="table table-bordered"
                    v-if="filteredList.length > 0"
                >
                    <thead>
                        <tr>
                            <th>Called Number</th>
                            <th>Duration (Min.)</th>
                            <th>Price (excl. VAT)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="cdr in filteredList"
                            :key="cdr.objKey"
                        >
                            <td>{{ cdr.calledNumber }}</td>
                            <td>{{ formattedDuration(cdr.duration) }}</td>
                            <td>{{ currencyFormat(cdr.priceExVat) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="alert alert-info">
                    Please select a Billing Period.
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ServiceScreenLayout>
  </div>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import SaleFunctions from "@/pages/Services/SaleFunctions";
import BillingFilter from "@/components/ObjParts/MultipleLoaded/BillingFilter";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
    BillingFilter,
  },
  data() {
    return {
      saleNumber: null,
      parts: [
        {
          name: "summary",
          icon: "fa fa-book",
          displayName: "Summary",
          permissions: ["*"],
        },
        {
          name: "cdr",
          icon: "fa fa-volume-control-phone",
          displayName: "Call Detail Records",
          permissions: ["*"],
        },
      ],
      saleDefinition: {
        definition:{
            minutes: {
                cdrs: [],
            },
        },
      },
      cdrPeriods: [],
      filteredList: [],
      summaryList: [],
    };
  },
  async mounted() {
    this.saleNumber = this.$route.params.saleNumber;
    this.getSaleDefinition(this.saleNumber).then(
      (success) => {
        this.saleDefinition = success.data;
        this.getCdrPeriods();
      },
      (error) => {
        console.error(error);
        this.showError("Error Fetching Sale Definition", error);
      }
    );
  },
  computed: {
  },
  methods: {
    formattedDuration(data) {
      var minutes = parseInt(data) / 60;
      var seconds = parseInt(data) % 60;

      return Math.trunc(minutes) + ":" + seconds;
      
    }, 
    loadSaleDefinition() {
      this.getSaleDefinition(this.saleNumber).then(
        (success) => {
          this.saleDefinition = success.data;
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
      return Promise.resolve('Success');
    },
    saveSaleDefinition: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .put(
              this.$config.aimsAPI +
                "sales/definition/" +
                this.saleDefinition.sale.saleNumber +
                "/update",
              this.saleDefinition
            )
            .then(
              (response) => {
                this.showSuccess("Save Success");
                this.saleDefinition = response.data;
                this.loadSaleDefinition();
              },
              (error) => {
                console.error(error);
                this.showError("Error Saving Voice Service", error);
              }
            );
        }
      });
    },
    getCdrPeriods() {
      var filteredArray = [];

      for (let i = 0; i < this.saleDefinition.definition.minutes.summary.length; i++) {
          filteredArray.push(this.getLabel(this.saleDefinition.definition.minutes.summary[i].billingPeriod));
      }

      this.cdrPeriods = [...new Set(filteredArray)];
    },
    getCdrForPeriod(period) {
      this.$http.get(this.$config.aimsAPI + "voiceminutes/cdr/" + this.saleDefinition.definition.minutes.voiceMinutesNumber + "/period/" + this.horrifyBillingPeriod(period)).then(
        (response) => {                            
          this.filteredList = response.data
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Usage", error);
        }
      );
    },
    changeSummary(data) {
      this.summaryList = data;
    },
    horrifyBillingPeriod(period) {
      var Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var year = period.substring(period.length-4, period.length);
      var month = '0';

      for (let i = 0; i < Months.length; i++) {
          if (period.includes(Months[i])) {
              if (i < 9) {
                  month = '0' + (i+1);
              } else {
                  month = (i+1);
              }
          }
      }

      var output = year + '' + month;
      return parseInt(output);
    },
    getLabel(period) {
      return this.prettifyBillingPeriod(period);
    },
  },
};
</script>

<style scoped>
.billing-period-select {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: #fff;
    font-size: 1rem;
    cursor: pointer;
    appearance: auto;
}

.billing-period-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>